// extracted by mini-css-extract-plugin
export var blockContainer = "cluster-navigation-module--blockContainer--y7elC";
export var blocks = "cluster-navigation-module--blocks--T8gmR";
export var navigation = "cluster-navigation-module--navigation--ko2lc";
export var scrollContainer = "cluster-navigation-module--scrollContainer--hCYxR";